module.exports = __webpack_public_path__ + "static/media/dom.b865eba1.jpg";